import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import DotsLoading from '../../../../components/dotsLoading';
import BuyerCard from '../../../../components/mazraeKit/cards/buyerCard';
import useGetBuyersList from '../../../../services/hookService/getBuyersList/useGetBuyersList';
import {RootState} from '../../../../store/redux';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';

const Buyers = ({isShop}: {isShop: boolean}) => {
  const navigate = useNavigate();
  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );

  const {buyersList, buyersListIsLoading} = useGetBuyersList({
    selected_cities_id: locational.map(item => item.id).join(',') || undefined,
    has_immediate: false,
    all_ads: true,
  });

  const buyers = buyersList?.results ?? [];

  if (buyersListIsLoading) {
    return <DotsLoading />;
  }

  if (!buyersListIsLoading && buyers.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col w-full gap-2 px-3">
      <div className="flex items-center justify-between w-full text-md">
        <h5 className="flex items-center p-0 m-0 text-gray-700 text-md">
          خریداران
        </h5>
        <button
          className="flex items-center text-sm text-farm-shop-500"
          onClick={() => {
            navigate('/buyers-listing');
            googleAnalyticsInstance.eventGoogleAnalytics({
              category: 'AllBuyers',
              action: 'رو مشاهده همه خریداران در صفحه هوم شاپ کلیک شد',
            });
          }}
        >
          مشاهده همه
          <SpanIcon className="text-lg icon-nameArrow---Left-2" />
        </button>
      </div>

      {buyersListIsLoading ? (
        <DotsLoading />
      ) : (
        <div className="w-full flex gap-2 h-[170px] items-center overflow-x-auto">
          <div className="flex gap-2">
            {buyersList?.results.map(item => (
              <BuyerCard
                state={item.state?.name || ''}
                city={item.city?.name || ''}
                time={item.created_at}
                message={item.title}
                phone={item.hide_phone_number}
                cardId={item.id}
                key={item.id}
                isShop={isShop}
                supplierGuid={item.supplier_guid}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Buyers;
